import { useTranslation } from 'react-i18next';
import { CustomizeProduct } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import Icon from 'components/Icon';
import type { ProductActionProps } from '../../shared/types';
import addCustomGiftCard from './action';

export function AddCustomGiftCardButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['CustomizeProduct']) {
    const { t } = useTranslation();

    return (
        <ButtonWithSpinner onClick={() => addCustomGiftCard({ params, trackingInfo })} type="button" {...restProps}>
            {children || t(CustomizeProduct)}
        </ButtonWithSpinner>
    );
}

export function AddCustomGiftCardButtonCompact({
    params,
    trackingInfo,
    ...restProps
}: ProductActionProps['BuyMinimumNow']) {
    const { t } = useTranslation();

    return (
        <ButtonWithIcon
            icon={<Icon type="BasketPlus" size={16} fill="currentColor" />}
            onClick={() => addCustomGiftCard({ params, trackingInfo })}
            type="button"
            aria-label={t(CustomizeProduct)}
            {...restProps}
        />
    );
}

export default Object.assign(AddCustomGiftCardButton, {
    Compact: AddCustomGiftCardButtonCompact
});
